export const iconFontAwesomeAstronomyUserAstronaut = (
	<i className="fa-solid fa-user-astronaut"></i>
);
